// If `pageSize` is not defined, then paging is disabled.
import { useState } from 'react';
import PageButton, { PageButtonDirection } from 'components/PageButton';
import { scrollToSection } from 'utils/common';

const PrizeList = ({ children, pageSize, style }) => {
	if (!children || children.length < 1) return null;

	const paginated = !isNaN(pageSize) && children.length > pageSize;
	const pageCount = paginated ? Math.ceil(children.length / pageSize) : null;

	const [currentPage, setCurrentPage] = useState(0);

	const windowStartIndex = paginated ? currentPage * pageSize : 0;
	const windowEndIndex = paginated ? ((currentPage + 1) * pageSize) - 1 : children.length - 1;
	const currentlyVisibleChildren = children.slice(windowStartIndex, windowEndIndex + 1);

	return (
		<div className='container' style={style}>
			<div className='prizeList'>
				{ currentlyVisibleChildren }
			</div>

			{ paginated && (
				<div className='pageControls'>
					<PageButton
						pageButtonDirection={PageButtonDirection.PREVIOUS}
						disabled={currentPage <= 0}
						onClick={() => {
							setCurrentPage(currentPage - 1);
							scrollToSection('.prizeList');
						}}
					/>

					<div className='pageCount'>
						Page { currentPage + 1 } / { pageCount }
					</div>

					<PageButton
						pageButtonDirection={PageButtonDirection.NEXT}
						disabled={currentPage + 1 >= pageCount}
						onClick={() => {
							setCurrentPage(currentPage + 1);
							scrollToSection('.prizeList');
						}}
					/>
				</div>
			)}

			<style jsx>{`
				.container {
					width: 100%;
				}
				
				.prizeList {
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					width: 100%;
				}
				
				.pageControls {
					display: flex;
					justify-content: center;
					align-items: center;
					max-width: 1050px;
					margin: 1em auto;
					padding: 0 2em;
				}
				
				.pageCount {
					font-weight: 800;
					font-size: 1.2rem;
					margin: 0 9px;
				}
			`}</style>
		</div>
	);
};

export default PrizeList;
